<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="店铺权限" name="authorization"></el-tab-pane>
        <el-tab-pane label="提报店铺" name="storePlanConfig"></el-tab-pane>
        <el-tab-pane label="预估节点" name="preSaleNode"></el-tab-pane>
        <el-tab-pane label="考核规则" name="assessmentRules" v-if="Jurisdiction"> </el-tab-pane>
        <el-tab-pane label="平台分类" name="platformClassification"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import authorization from "../authorization/authorization";
import storePlanConfig from "../storePlanConfig/storePlanConfig";
import preSaleNode from "../preSaleNode/preSaleNode";
import assessmentRules from "../assessmentRules/assessmentRules";
import platformClassification from "../platformClassification/platformClassification";
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  components: { authorization, storePlanConfig, preSaleNode, assessmentRules, platformClassification },
  mixins: [pagePathMixin],
  data() {
    return {
      activeName: null,
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
    Jurisdiction() {
      let buttonJurisdiction = JSON.parse(localStorage.getItem("permitList")); //列展示权限获取
      let Jurisdiction = "ec-pc-new$advanceSalesManagement$preSalePlan$preSalePlan$rules";
      return buttonJurisdiction.includes(Jurisdiction);
    },
  },
  mounted() {
    this.activeName = "authorization";
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
